import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/layouts/default.vue").then(m => m.default || m)),
  minimal: defineAsyncComponent(() => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/layouts/minimal.vue").then(m => m.default || m)),
  order: defineAsyncComponent(() => import("/build/36f08e23-6a83-4279-8f1c-8d0fc3d1d99b/layouts/order.vue").then(m => m.default || m))
}